export const froalaConfig = {
    // Configuración del editor https://froala.com/wysiwyg-editor/docs/options
    imageUploadRemoteUrls: false,
    language: "es",
    toolbarButtons: [
        [
            "undo",
            "redo",
            "bold",
            "fontSize",
            "fontFamily",
            "textColor",
            "paragraphFormat",
            "backgroundColor",
            "alignLeft",
            "alignCenter",
            "alignRight",
            "quote",
            "insertImage",
            "insertVideo",
            "clearFormatting",
            "insertTable",
            "formatOLSimple",
            "fontAwesome",
            "fullscreen",
        ],
    ],
    imageInsertButtons: ["imageByURL"],
    videoInsertButtons: ["videoBack", "|", "videoByURL"],
    quickInsertEnabled: false,
    toolbarVisibleWithoutSelection: false,
    toolbarSticky: false,
    imageMove: true,
    events: {
        click: function (clickEvent) {
            // Do something here.
            // this is the editor instance.
            console.log(this);
        },
    },
}